import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DetailsOfItemsTransfer = {
    name: NAME,
    apiProvider,
    router,
};
